import { tw } from '@/utils/tw';
import BaseExpertSliderTheme from 'base/components/ExpertSlider/theme';

const Slider = tw.theme({
  extend: BaseExpertSliderTheme.Slider,
});

const Image = tw.theme({
  extend: BaseExpertSliderTheme.Image,
  slots: {
    base: [
      'group-[&:nth-child(n+1)]/slide:bg-[#FFD960]',
      'group-[&:nth-child(n+2)]/slide:bg-[#FF71AC]',
      'group-[&:nth-child(n+3)]/slide:bg-[#00AFE6]',
      'data-[fill]:!aspect-[0.72/1]',
      'sm:pt-4',
      'pt-2',
    ],
  },
});

const ExpertSlider = tw.theme({
  extend: BaseExpertSliderTheme,
  slots: {
    headline: ['text-headline-xs'],
    caption: ['text-primary-700', 'text-headline-xs', 'my-1.5', 'block'],
    description: ['text-headline-sm', 'sm:text-headline-md'],
  },
});

export default Object.assign(ExpertSlider, { Image, Slider });
